'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var _extends = require('@babel/runtime/helpers/extends');
var _objectWithoutProperties = require('@babel/runtime/helpers/objectWithoutProperties');
var React = require('react');
var react = require('@chakra-ui/react');
var ReactSelect = require('react-select');
var getReactSelectConfiguration = require('./getReactSelectConfiguration.js');
function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}
var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var _objectWithoutProperties__default = /*#__PURE__*/_interopDefaultLegacy(_objectWithoutProperties);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var ReactSelect__default = /*#__PURE__*/_interopDefaultLegacy(ReactSelect);
var _excluded = ["size", "variant", "reactSelectComponent", "placeholder", "options", "isDisabled", "isInvalid", "isReadOnly"];
var CustomReactSelect = react.forwardRef(function (props, ref) {
  var _props$size = props.size,
    size = _props$size === void 0 ? 'md' : _props$size,
    _props$variant = props.variant,
    variant = _props$variant === void 0 ? 'default' : _props$variant,
    _props$reactSelectCom = props.reactSelectComponent,
    reactSelectComponent = _props$reactSelectCom === void 0 ? ReactSelect__default["default"] : _props$reactSelectCom,
    _props$placeholder = props.placeholder,
    placeholder = _props$placeholder === void 0 ? 'Bitte wählen' : _props$placeholder,
    _props$options = props.options,
    options = _props$options === void 0 ? [] : _props$options,
    isDisabledProp = props.isDisabled,
    isInvalidProp = props.isInvalid,
    isReadOnlyProp = props.isReadOnly,
    rest = _objectWithoutProperties__default["default"](props, _excluded);
  var theme = react.useTheme();
  var fieldProps = react.useFormControl(props);
  // Compared to normal inputs, the various state styles are handled via props only.
  // On normal inputs, (aria-) attributes are used to style, which is where
  // `useFormControl` would be enough - however, we need the whole context for
  // `react-select`.
  var formControlProps = react.useFormControlContext();
  var isDisabled = isDisabledProp !== null && isDisabledProp !== void 0 ? isDisabledProp : formControlProps === null || formControlProps === void 0 ? void 0 : formControlProps.isDisabled;
  var isInvalid = isInvalidProp !== null && isInvalidProp !== void 0 ? isInvalidProp : formControlProps === null || formControlProps === void 0 ? void 0 : formControlProps.isInvalid;
  var isReadOnly = isReadOnlyProp !== null && isReadOnlyProp !== void 0 ? isReadOnlyProp : formControlProps === null || formControlProps === void 0 ? void 0 : formControlProps.isReadOnly;
  var configuration = React.useMemo(function () {
    return getReactSelectConfiguration["default"]({
      size: size,
      variant: variant,
      isDisabled: isDisabled,
      isInvalid: isInvalid,
      isReadOnly: isReadOnly,
      theme: theme
    });
  }, [size, variant, isInvalid, isDisabled, isReadOnly, theme]);

  // It is a bit fucky when it comes to types, but it's valid and works.
  return /*#__PURE__*/React__default["default"].createElement(react.chakra.div, _extends__default["default"]({
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    as: reactSelectComponent
  }, configuration, {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    placeholder: props.isRequired && placeholder ? "".concat(placeholder, " *") : placeholder,
    options: options
  }, fieldProps, rest, {
    isDisabled: isDisabled,
    ref: ref
  }));
});
exports["default"] = CustomReactSelect;